import { render, staticRenderFns } from "./TemplateGroup.vue?vue&type=template&id=03542120&scoped=true&"
import script from "./TemplateGroup.vue?vue&type=script&lang=js&"
export * from "./TemplateGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03542120",
  null
  
)

export default component.exports